import { getDealerRooftopId } from 'site-modules/shared/utils/dealer';

/**
 * Tracking helper
 *
 * @type {Object}
 */
export const TrackingHelper = {
  getBasicDealerOptions(options) {
    let partnerId;

    const location = options.state && options.state.pageContext.location;
    const dealerId = getDealerRooftopId(options.state);
    const dealerInfo = options.state.dealerData.dealerInfo;

    if (dealerId) {
      partnerId = dealerInfo?.id?.[dealerId]?.id;
    }

    if (!partnerId) {
      const pathNameMatch = location.pathname.match(/(\w+)/g);
      const dealerLogicalName = pathNameMatch[pathNameMatch.length - 1];
      partnerId = dealerInfo?.name?.[dealerLogicalName]?.id;
    }

    return {
      partner_id: partnerId,
    };
  },
};
